// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { LAYOUT } from 'constant/layout.constant'
import { TUK_MODULE, TUK_URL } from 'constant/url.constant'

// UI
const { TukpageIndex } = lazily(() => import('pages/webpage/tuk'))

const tukRoutes: IRoute[] = [
  {
    path: TUK_URL.INDEX,
    component: TukpageIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: TUK_MODULE,
      requireAuth: false,
      attrs: {
        label: 'webpageTuk.tuk',
      },
    },
  },
]

export { tukRoutes }
